import { array, object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  icd10Codes: array().of(
    object().shape({
      name: string().trim().max(100, 'Max length - 100 symbols').required('Field is required'),
      description: string()
        .trim()
        .max(500, 'Max length - 500 symbols')
        .required('Field is required'),
    }),
  ),
});

export default yupResolver(validationSchema);
